"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSuccessReducer = exports.updateStartReducer = exports.updateFailureReducer = exports.isSuccess = exports.isLoading = exports.isErrored = exports.initialEntityCollectionState = exports.fetchSuccessReducer = exports.fetchStartReducer = exports.fetchAllPaginatedResults = exports.erroredReducer = exports.createOrderedListSelector = exports.STATUS_KEY = exports.FetchStatus = void 0;
var _toolkit = require("@reduxjs/toolkit");
let FetchStatus = exports.FetchStatus = /*#__PURE__*/function (FetchStatus) {
  FetchStatus["Initial"] = "INITIAL";
  FetchStatus["Loading"] = "LOADING";
  FetchStatus["Success"] = "SUCCESS";
  FetchStatus["Error"] = "ERROR";
  return FetchStatus;
}({});
const STATUS_KEY = exports.STATUS_KEY = "status";
const initialEntityCollectionState = exports.initialEntityCollectionState = {
  [STATUS_KEY]: FetchStatus.Initial,
  entitiesMap: {},
  orderedIds: [],
  pendingUpdatesMap: {}
};
const isLoading = state => state[STATUS_KEY] === FetchStatus.Loading;
exports.isLoading = isLoading;
const isErrored = state => state[STATUS_KEY] === FetchStatus.Error;
exports.isErrored = isErrored;
const isSuccess = state => state[STATUS_KEY] === FetchStatus.Success;
exports.isSuccess = isSuccess;
const erroredReducer = state => {
  state[STATUS_KEY] = FetchStatus.Error;
};
exports.erroredReducer = erroredReducer;
const updateStartReducer = (state, action) => {
  state.pendingUpdatesMap[action.payload.id] = action.payload.entityChanges;
};
exports.updateStartReducer = updateStartReducer;
const updateSuccessReducer = (state, action) => {
  delete state.pendingUpdatesMap[action.payload.id];
  state.entitiesMap[action.payload.id] = action.payload;
};
exports.updateSuccessReducer = updateSuccessReducer;
const updateFailureReducer = (state, action) => {
  delete state.pendingUpdatesMap[action.payload.id];
};
exports.updateFailureReducer = updateFailureReducer;
const fetchSuccessReducer = (state, action) => {
  state[STATUS_KEY] = FetchStatus.Success;
  state.entitiesMap = action.payload.reduce((acc, entity) => {
    acc[entity.id] = entity;
    return acc;
  }, state.entitiesMap);
  state.orderedIds = action.payload.map(entity => entity.id);
  state.newEntityIds = [];
  state.pendingUpdatesMap = {};
};
exports.fetchSuccessReducer = fetchSuccessReducer;
const fetchStartReducer = state => {
  state.entitiesMap = initialEntityCollectionState.entitiesMap;
  state.orderedIds = initialEntityCollectionState.orderedIds;
  state[STATUS_KEY] = FetchStatus.Loading;
};
exports.fetchStartReducer = fetchStartReducer;
const createOrderedListSelector = getInternalState => (0, _toolkit.createSelector)(state => getInternalState(state).orderedIds, state => getInternalState(state).entitiesMap, state => getInternalState(state).pendingUpdatesMap, state => getInternalState(state).newEntityIds, function (orderedIds, entitiesMap, pendingUpdatesMap) {
  let newEntityIds = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  return [...newEntityIds, ...orderedIds].map(id => {
    const entity = entitiesMap[id];
    if (!entity) {
      return undefined;
    }
    return {
      ...entity,
      ...pendingUpdatesMap[id]
    };
  }).filter(Boolean);
});

/**
 * Gets all the results from a paginated response sequentially
 * @param fetchNextPage a function that returns a promise with the next paginated response
 */
exports.createOrderedListSelector = createOrderedListSelector;
const fetchAllPaginatedResults = async fetchNextPage => {
  const allResults = [];
  let offset = 0;
  let pagination;
  let results;
  do {
    const response = await fetchNextPage(offset);
    pagination = response.pagination;
    results = response.results;
    offset += results.length;
    allResults.push(...results);
  } while (pagination.totalResults > pagination.offset + results.length);
  return allResults;
};
exports.fetchAllPaginatedResults = fetchAllPaginatedResults;
//# sourceMappingURL=fetchHelpers.js.map